import React, { Component, useEffect, useState, useRef } from "react";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from 'react-cookie';
import { LoginAdminTOAgentConfirmation, getwishlistfitsingleData} from './axios';
import { useParams } from "react-router-dom";

import "./AgentSignup.css";
import {  useDispatch } from 'react-redux';
import { createStore } from "redux";
import { addToCart, clearToCart } from "../redux/actions/actions";

export default function MytripSavedtoitinerary() {

  const { id } = useParams();
  const email = atob(id);
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const plan_id = atob(urlParams.get("plan_id"));

  const dispatch = useDispatch();

  useEffect(() => {
    LoginAdminTOAgentConfirmation(email).then(
      (data) => {
        if (data == 'not_correct') {
          let text = "This is not correct.";
          if (window.confirm(text) == true) {
          }
      } else {
          let Verified = '';
          if (data.verified == 1) {
              Verified = true;
          }
          const dataSearch = {
              first_name: data.first_name,
              last_name: data.last_name,
              email: data.email,
              country_code: data.country_code,
              verified: Verified,
              uid: data.id
          }
          let JsonData = JSON.stringify(dataSearch);
          localStorage.setItem('userDetails', JsonData);
       
         getwishlistfitsingleData(plan_id).then(
          (data) => {
         
          dispatch(clearToCart());
          var plandetailsNew =  JSON.parse(data?.plan_details);
          plandetailsNew.map((newData, j) => {
        
          dispatch(addToCart(newData));
          })
           setTimeout(function () { 
          const url = "/itineraryDetails?moreLocation=" + encodeURIComponent(JSON.stringify(data?.morelocation)) + "&checkin=" + encodeURIComponent(data?.checkin_date) + "&checkout=" + encodeURIComponent(data?.checkout_date) + "&guestCombination=" + (data?.guest_combination) + "&itineraryPlan=" + encodeURIComponent(data?.itinerary_plan) + "&changeDate=" + encodeURIComponent(JSON.stringify(data?.change_date)) + "&selectedStartLocation="+encodeURIComponent(data?.start_location) + "&selectedEndLocation="+encodeURIComponent(data?.end_location);
            window.location.replace(url);
          },  1000);
          },
          (error) => {}
        );

      }
      },
      (error) => {}
    );
  
}, []);
    return (
      <div id="login">
      </div>
        );
   
}